<template>
  <div class="regBox">
    <div class="regTitle fs22 ftc22 ftb">招标管理系统</div>
    <!-- <div class="regTitle fs22 ftc22 ftb">重庆交运集团废旧物资处置平台</div> -->
    <div class="regForm">
      <div class="isPersonal">
        <span
          class="company"
          :class="current == 1 ? 'active' : ''"
          @click="changeLogin(1)"
          >公司客户</span
        >
        <span
          class="personal"
          :class="current == 2 ? 'active' : ''"
          @click="changeLogin(2)"
          >个人客户</span
        >
      </div>
    </div>
    <personal v-if="current == 2" :personalObj="personalObj"></personal>
    <company v-if="current == 1" :companyObj="companyObj"></company>
  </div>
</template>

<script>
import personal from "./common/personal";
import company from "./common/company";
export default {
  components: {
    personal,
    company,
  },
  data() {
    return {
      current: 1,
      personalObj: {},
      companyObj: {},
    };
  },
  mounted() {
    // 判断是否是未审核重新提交进入的
    if (this.$route.query.id == 1) {
      let a = JSON.parse(localStorage.getItem("modifyArr"));
      if (localStorage.getItem("modifyArr")) {
        if (a.type == 1) {
          this.companyObj = a;
          this.current = 1;
        } else {
          this.personalObj = a;
          this.current = 2;
        }
      }
    }
  },
  methods: {
    changeLogin(val) {
      this.current = val;
    },
  },
};
</script>

<style lang="less" scoped>
.active {
  color: #14d393;
}

.active::before {
  content: "";
  position: absolute;
  bottom: -8px;
  padding: 1px 22px;
  background: #14d393;
  left: 50%;
  transform: translate(-50%, -50%);
}

.regBox {
  width: 100%;
  height: 100%;

  .regTitle {
    padding: 16px 0;
    border-bottom: 1px solid #f0f0f0;
    text-align: center;
  }

  .regForm {
    .isPersonal {
      display: flex;
      justify-content: center;
      padding: 20px 0;

      .personal,
      .company {
        position: relative;
        padding: 4px 80px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/reg/index.vue